import styles from './AccountSettings.module.scss';
import { ReactElement } from 'react';
import { clearBestellung } from '../../store/Bestellung.store';
import FlutterBridge from '../../flutter/flutterBridge';
import { ALLOW_COOKIES_KEY } from '../../localStorage';
import { showConfirmationDialog } from '../../shared/ui-components/ConfirmationDialog/confirmationDialog';
import { useDispatch, useSelector } from 'react-redux';
import { routes, selectHasOpenBestellung } from '../../store/Workflow.store';
import { ACCOUNT_DELETION_EMAIL } from '../../shared/constants';
import accountIcon from '../../assets/icon-account.svg';
import keycloak from '../../index';
import { selectCurrentUser } from '../../store/keycloak.store';
import Button from '../../shared/ui-components/Button/Button';

const AccountSettings = (): ReactElement => {
    const currentUser = useSelector(selectCurrentUser);
    const dispatch = useDispatch();
    const hasOpenBestellung = useSelector(selectHasOpenBestellung);

    const logout = (logoutUrl: string): void => {
        dispatch(clearBestellung());
        FlutterBridge.sendToken(null);
        const allowCookies = localStorage.getItem(ALLOW_COOKIES_KEY);
        localStorage.clear();
        if (allowCookies !== null) {
            localStorage.setItem(ALLOW_COOKIES_KEY, allowCookies);
        }

        window.location.href = logoutUrl;
    };

    const confirmLogoutDialog = (logoutUrl: string): void => {
        showConfirmationDialog({
            message: (
                <>
                    Sie haben noch eine Bestellung, die nicht abgeschlossen ist. Wenn Sie fortfahren werden Ihre Bestellpositionen gelöscht.
                </>
            ),
            okButtonText: 'Bestellpositionen löschen',
            onOkCallback: () => {
                logout(logoutUrl);
            },
        });
    };

    const shouldLogout = () => {
        const redirectUri = `${window.location.origin}/`;
        const logoutUrl = (keycloak.createLogoutUrl && keycloak?.createLogoutUrl?.({ redirectUri })) || '';
        if (hasOpenBestellung) {
            confirmLogoutDialog(logoutUrl);
        } else {
            logout(logoutUrl);
        }
    };

    return (
        <div className={styles._accountSettingsContainer}>
            <div className={styles._topSide}>
                <div className={styles._accountInfoContainer}>
                    <img src={accountIcon} alt="AccountInfo" className={styles._accountIcon} /> <br />
                    <div className={styles._userIdentificationContainer}>
                        <h3 className={styles._username}> {currentUser?.name} </h3>
                        <p className={styles._usermail}> {currentUser?.email}</p>
                    </div>
                </div>
                <div>
                    <h3 className={styles._accountSettingsHeader}>Account & Sicherheit</h3>
                    <div className={styles._accountLoeschenContainer}>
                        <Button>
                            <a
                                href={`mailto:${ACCOUNT_DELETION_EMAIL}?subject=Löschen des Accounts`}
                                className={styles._accountLoeschen}
                                onClick={() => {
                                    window.umami?.track('sidebar-navigation-click', {
                                        entryName: 'account-loeschen',
                                    });
                                }}
                            >
                                <>Account löschen</>
                            </a>
                        </Button>
                    </div>
                </div>
            </div>
            <div className={styles._buttonContainer}>
                <Button onClick={shouldLogout} isSecondary className={styles._signOutButton}>
                    Abmelden
                </Button>
            </div>
        </div>
    );
};

export default AccountSettings;
